import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_feedback_form = _resolveComponent("feedback-form")!
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.loading && typeof(_ctx.practice_visit) !== 'undefined')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_feedback_form, {
            is_practice: true,
            visit: _ctx.practice_visit
          }, null, 8, ["visit"])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.loading && typeof(_ctx.practice_visit) === 'undefined')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[0] || (_cache[0] = _createElementVNode("h4", null, "Error Loading SP Scorecard Practice", -1)),
          _createElementVNode("p", null, _toDisplayString(_ctx.loadErrorMessage), 1)
        ]))
      : _createCommentVNode("", true),
    _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
    _createVNode(_component_loading, {
      active: _ctx.loading,
      "is-full-page": true
    }, null, 8, ["active"])
  ], 64))
}